import { createLogger as ae } from "@origo/logger";
import * as pe from "@arcgis/core/geometry/operators/areaOperator";
import * as ge from "@arcgis/core/geometry/operators/intersectionOperator";
import * as ke from "@arcgis/core/geometry/operators/intersectsOperator";
import be from "@arcgis/core/layers/support/CodedValueDomain";
import de from "@arcgis/core/request";
import Re from "@arcgis/core/rest/support/FeatureSet";
import Ae from "@arcgis/core/layers/FeatureLayer";
import { queryOptions as O, useQuery as S } from "@tanstack/react-query";
import { jsx as Ee } from "react/jsx-runtime";
import { createContext as Ne, useMemo as Fe, useContext as oe } from "react";
function Oe(e) {
  return `${e.planStat ?? ""}-${e.vertNiv ?? ""}-${e.planId ?? ""}-${e.objectId ?? ""}`;
}
class M extends Error {
  constructor(r, n) {
    super(r), this.cause = n, this.name = this.constructor.name;
  }
}
class Se extends M {
  constructor(r, n) {
    super(`${r} ikke funnet: ${n}`);
  }
}
class Ie extends M {
}
class C extends M {
}
class Pe extends M {
}
class J extends M {
  constructor() {
    super("Operasjonen ble avbrutt");
  }
}
class H extends M {
}
const Ar = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedError: J,
  ArealplanError: M,
  AuthError: Pe,
  ConfigurationError: H,
  NetworkError: C,
  NotFoundError: Se,
  ValidationError: Ie,
  planKey: Oe
}, Symbol.toStringTag, { value: "Module" })), ie = {
  minRatio: 0.01,
  minAreaM2: 1 / 0
};
function X(e) {
  try {
    return Math.abs(pe.execute(e, { unit: "square-meters" }));
  } catch {
    return 0;
  }
}
function me(e, r, n = {}) {
  if (!e || !r)
    return { keep: !0, reason: "missing-geometry" };
  const t = n.minAreaM2 ?? ie.minAreaM2, a = n.minRatio ?? ie.minRatio, o = e.spatialReference?.wkid, i = r.spatialReference?.wkid;
  if (o != null && i != null && o !== i)
    return { keep: !0, reason: "sr-mismatch", srcWkid: o, candWkid: i };
  const s = e, R = r;
  try {
    if (!ke.execute(s, R))
      return { keep: !1, reason: "no-intersect", srcWkid: o, candWkid: i };
  } catch {
    return { keep: !0, reason: "intersect-error", srcWkid: o, candWkid: i };
  }
  let m;
  try {
    m = ge.execute(s, R);
  } catch {
    return { keep: !0, reason: "intersection-error", srcWkid: o, candWkid: i };
  }
  if (!m)
    return o != null && i != null && o === i ? { keep: !1, reason: "touch-no-area", srcWkid: o, candWkid: i, overlapAreaM2: 0, ratio: 0 } : { keep: !0, reason: "intersection-null", srcWkid: o, candWkid: i };
  const K = X(m), h = X(e), v = X(r), U = Math.min(h, v), Q = U > 0 ? K / U : 0, l = { srcWkid: o, candWkid: i, overlapAreaM2: K, sourceAreaM2: h, candidateAreaM2: v, ratio: Q };
  return Q >= a ? { keep: !0, reason: "ratio-pass", ...l } : K >= t ? { keep: !0, reason: "area-pass", ...l } : { keep: !1, reason: "below-threshold", ...l };
}
function se(e, r, n = {}) {
  return me(e, r, n).keep;
}
const ve = /^(Kommuneplan|Kommunedelplan|Reguleringsplan|Bebyggelsesplan)/i, Te = /^Dispensasjon/i, he = /^PblMidlForbud/i, ne = {
  // Reguleringsplan (Rp-prefiks) — arealformål
  RpArealformålOmråde: {
    canonical: "RpArealformålOmråde",
    aliases: ["RpArealformålOmråde", "RpArealformalOmrade", "RpArealformaalOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "RPAREALFORMAL"
  },
  RpBestemmelseOmråde: {
    canonical: "RpBestemmelseOmråde",
    aliases: ["RpBestemmelseOmråde", "RpBestemmelseOmrade"],
    headingFelt: "BESTEMMELSEOMRNAVN",
    typeFelt: "RPBESTEMMELSEHJEMMEL"
  },
  RpAngittHensynSone: {
    canonical: "RpAngittHensynSone",
    aliases: ["RpAngittHensynSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPANGITTHENSYN"
  },
  RpBåndleggingSone: {
    canonical: "RpBåndleggingSone",
    aliases: ["RpBåndleggingSone", "RpBandleggingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPBANDLEGGING"
  },
  RpDetaljeringSone: {
    canonical: "RpDetaljeringSone",
    aliases: ["RpDetaljeringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPDETALJERING"
  },
  RpFareSone: {
    canonical: "RpFareSone",
    aliases: ["RpFareSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPFARE"
  },
  RpGjennomføringSone: {
    canonical: "RpGjennomføringSone",
    aliases: ["RpGjennomføringSone", "RpGjennomforingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPGJENNOMFORING"
  },
  RpInfrastrukturSone: {
    canonical: "RpInfrastrukturSone",
    aliases: ["RpInfrastrukturSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPINFRASTRUKTUR"
  },
  RpSikringSone: {
    canonical: "RpSikringSone",
    aliases: ["RpSikringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPSIKRING"
  },
  RpStøySone: {
    canonical: "RpStøySone",
    aliases: ["RpStøySone", "RpStoySone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPSTOY"
  },
  // Reguleringsplan/Bebyggelsesplan etter gammel lov (Rb-prefiks)
  RbArealbrukOmråde: {
    canonical: "RbArealbrukOmråde",
    aliases: ["RbArealbrukOmråde", "RbArealbrukOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbFormålOmråde: {
    canonical: "RbFormålOmråde",
    aliases: ["RbFormålOmråde", "RbFormalOmrade", "RbFormaalOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbBevaringOmråde: {
    canonical: "RbBevaringOmråde",
    aliases: ["RbBevaringOmråde", "RbBevaringOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbFareOmråde: {
    canonical: "RbFareOmråde",
    aliases: ["RbFareOmråde", "RbFareOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbFornyelseOmråde: {
    canonical: "RbFornyelseOmråde",
    aliases: ["RbFornyelseOmråde", "RbFornyelseOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbRekkefølgeOmråde: {
    canonical: "RbRekkefølgeOmråde",
    aliases: ["RbRekkefølgeOmråde", "RbRekkefolgeOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbRestriksjonOmråde: {
    canonical: "RbRestriksjonOmråde",
    aliases: ["RbRestriksjonOmråde", "RbRestriksjonOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  // Kommuneplan / Kommunedelplan (Kp-prefiks) — arealformål
  KpArealformålOmråde: {
    canonical: "KpArealformålOmråde",
    aliases: ["KpArealformålOmråde", "KpArealformalOmrade"],
    headingFelt: "OMRNAVN",
    typeFelt: "KPAREALFORMAL"
  },
  KpArealbrukOmråde: {
    canonical: "KpArealbrukOmråde",
    aliases: ["KpArealbrukOmråde", "KpArealbrukOmrade"],
    headingFelt: "OMRNAVN",
    typeFelt: "OPLAREAL"
  },
  KpBestemmelseOmråde: {
    canonical: "KpBestemmelseOmråde",
    aliases: ["KpBestemmelseOmråde", "KpBestemmelseOmrade"],
    headingFelt: "BESTEMMELSEOMRNAVN",
    typeFelt: "KPBESTEMMELSEHJEMMEL"
  },
  KpRestriksjonOmråde: {
    canonical: "KpRestriksjonOmråde",
    aliases: ["KpRestriksjonOmråde", "KpRestriksjonOmrade"],
    headingFelt: "OBJTYPE",
    typeFelt: "OPLRESTR"
  },
  KpRetningslinjeOmråde: {
    canonical: "KpRetningslinjeOmråde",
    aliases: ["KpRetningslinjeOmråde", "KpRetningslinjeOmrade"],
    headingFelt: "OBJTYPE",
    typeFelt: "OPLRETNL"
  },
  KpAngittHensynSone: {
    canonical: "KpAngittHensynSone",
    aliases: ["KpAngittHensynSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPANGITTHENSYN"
  },
  KpBåndleggingSone: {
    canonical: "KpBåndleggingSone",
    aliases: ["KpBåndleggingSone", "KpBandleggingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPBANDLEGGING"
  },
  KpDetaljeringSone: {
    canonical: "KpDetaljeringSone",
    aliases: ["KpDetaljeringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPDETALJERING"
  },
  KpFareSone: {
    canonical: "KpFareSone",
    aliases: ["KpFareSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPFARE"
  },
  KpGjennomføringSone: {
    canonical: "KpGjennomføringSone",
    aliases: ["KpGjennomføringSone", "KpGjennomforingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPGJENNOMFORING"
  },
  KpInfrastrukturSone: {
    canonical: "KpInfrastrukturSone",
    aliases: ["KpInfrastrukturSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPINFRASTRUKTUR"
  },
  KpSikringSone: {
    canonical: "KpSikringSone",
    aliases: ["KpSikringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPSIKRING"
  },
  KpStøySone: {
    canonical: "KpStøySone",
    aliases: ["KpStøySone", "KpStoySone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPSTOY"
  },
  // PBL midlertidig (Pbl-prefiks)
  PblMidlByggAnleggOmråde: {
    canonical: "PblMidlByggAnleggOmråde",
    aliases: ["PblMidlByggAnleggOmråde", "PblMidlByggAnleggOmrade"],
    headingFelt: "BESTEMMELSEOMRNAVN",
    typeFelt: "OBJTYPE"
  }
}, Z = Array.from(
  new Set(Object.values(ne).flatMap((e) => e.aliases))
);
function $(e) {
  if (!e)
    return;
  const r = ne[e];
  if (r)
    return r;
  for (const n of Object.values(ne))
    if (n.aliases.includes(e))
      return n;
}
const x = {
  Reguleringsplan: ["RpOmrade"],
  Bebyggelsesplan: ["RpOmrade"],
  Kommuneplan: ["KpOmrade"],
  Kommunedelplan: ["KpOmrade"],
  Dispensasjon: ["DispensasjonPunkt"],
  PblMidlForbud: ["PblMidlForbudMotTiltakFlate"]
};
function ee(e) {
  if (x[e])
    return x[e];
  const r = e.replace(/(_UA)?(_VN\d+)?$/, "");
  if (x[r])
    return x[r];
  for (const [n, t] of Object.entries(x))
    if (e.includes(n))
      return t;
  return [];
}
const Be = {
  PLANID: "planId",
  LOKALID: "lokalId",
  GlobalID: "globalId",
  OBJECTID: "objectId",
  PLANNAVN: "planNavn",
  PLANSTAT: "planStat",
  PLANTYPE: "planTypeKey",
  VERTNIV: "vertNiv",
  IKRAFT: "ikraft",
  BESKRIVELSE: "beskrivelse",
  KOMMUNENUMMER: "kommunenummer",
  PLANBEST: "planBestemmelser",
  LOVREFERANSE: "lovreferanse",
  PLANREGISTERLINK: "planRegisterLink"
};
function Le(e) {
  const r = {};
  if (e)
    for (const [n, t] of Object.entries(e)) {
      const a = Be[n];
      a && t != null && (r[a] = String(t));
    }
  return Object.keys(r).length > 0 ? r : void 0;
}
function le(e, r, n) {
  return {
    planId: String(e.PLANID ?? ""),
    lokalId: e.LOKALID ?? void 0,
    globalId: e.GlobalID ?? void 0,
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    planTypeKey: r,
    planNavn: e.PLANNAVN ?? void 0,
    planStat: e.PLANSTAT ?? void 0,
    vertNiv: e.VERTNIV ?? void 0,
    ikraft: e.IKRAFT ?? void 0,
    beskrivelse: e.BESKRIVELSE ?? void 0,
    kommunenummer: e.KOMMUNENUMMER ?? void 0,
    planBestemmelser: e.PLANBEST ?? void 0,
    lovreferanse: e.LOVREFERANSE ?? void 0,
    planRegisterLink: e.PLANREGISTERLINK ?? void 0,
    displayValues: Le(n)
  };
}
function je(e) {
  if (typeof e.LOKALID == "string" && e.LOKALID.trim() !== "")
    return e.LOKALID.trim();
  if (typeof e.GlobalID == "string" && e.GlobalID.trim() !== "")
    return e.GlobalID.trim();
  const r = e.OBJTYPE, n = e.OBJECTID;
  if (typeof r == "string" && r.trim() !== "" && n != null)
    return `${r.trim()}-${n}`;
}
function Me(e) {
  const r = $(typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0);
  if (!r)
    return;
  const n = e[r.typeFelt];
  return n == null ? void 0 : String(n);
}
function Ke(e, r) {
  const n = $(typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0);
  if (!n)
    return;
  const t = r[n.typeFelt];
  return t == null ? void 0 : String(t);
}
function De(e) {
  const r = $(typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0);
  if (!r)
    return;
  const n = e[r.headingFelt];
  return n == null ? void 0 : String(n);
}
function re(e, r, n, t) {
  return {
    omradeId: je(e),
    planId: String(e.PLANID ?? ""),
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    objtype: typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0,
    arealformål: Me(e),
    arealformålDisplay: Ke(e, n),
    feltnavn: De(e),
    geometri: r,
    planTypeKey: t,
    attributter: { ...e },
    displayValues: n
  };
}
const we = {
  OBJECTID: "objectId",
  planId: "planId",
  pbltiltak: "pblTiltak",
  beskrivelse: "beskrivelse",
  dispensasjonType: "dispensasjonType",
  vedtaksdato: "vedtaksdato",
  tiltaksnr: "tiltaksnr",
  dispFra: "dispFra",
  vedtakId: "vedtakId",
  vedtak: "vedtak",
  sak_id: "sakId",
  sak_sakAar: "sakAar",
  sak_sakSeknr: "sakSeknr",
  sak_arkivId: "sakArkivId",
  sak_url: "sakUrl",
  sak_urlIntern: "sakUrlIntern",
  vedtak_urlEkstern: "vedtakUrlEkstern"
};
function Ge(e) {
  const r = {};
  for (const [n, t] of Object.entries(e)) {
    const a = we[n];
    r[a ?? n] = t;
  }
  return r;
}
function xe(e, r, n, t) {
  return {
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    planId: typeof e.planId == "string" ? e.planId : void 0,
    planTypeKey: t,
    pblTiltak: typeof e.pbltiltak == "string" ? e.pbltiltak : void 0,
    beskrivelse: typeof e.beskrivelse == "string" ? e.beskrivelse : void 0,
    dispensasjonType: typeof e.dispensasjonType == "string" ? e.dispensasjonType : void 0,
    vedtaksdato: e.vedtaksdato ?? void 0,
    tiltaksnr: typeof e.tiltaksnr == "string" ? e.tiltaksnr : void 0,
    dispFra: typeof e.dispFra == "string" ? e.dispFra : void 0,
    vedtakId: typeof e.vedtakId == "string" ? e.vedtakId : void 0,
    vedtak: typeof e.vedtak == "string" ? e.vedtak : void 0,
    sakId: typeof e.sak_id == "string" ? e.sak_id : void 0,
    sakAar: e.sak_sakAar ?? void 0,
    sakSeknr: e.sak_sakSeknr ?? void 0,
    sakArkivId: typeof e.sak_arkivId == "string" ? e.sak_arkivId : void 0,
    sakUrl: typeof e.sak_url == "string" ? e.sak_url : void 0,
    sakUrlIntern: typeof e.sak_urlIntern == "string" ? e.sak_urlIntern : void 0,
    vedtakUrlEkstern: typeof e.vedtak_urlEkstern == "string" ? e.vedtak_urlEkstern : void 0,
    geometri: r,
    attributter: { ...e },
    displayValues: Ge(n)
  };
}
const qe = {
  OBJECTID: "objectId",
  PBLTILTAKFORBUDTYPE: "tiltakforbudType",
  INFORMASJON: "informasjon",
  AVGJDATO: "avgjørelsesdato",
  GYLDIGTILDATO: "gyldigTilDato",
  FORSTEDIGITALISERINGSDATO: "førsteDigitaliseringsdato",
  SAKSAR: "saksAar",
  SAKSSEKVENSNUMMER: "saksSekvensnummer"
};
function _e(e) {
  const r = {};
  for (const [n, t] of Object.entries(e)) {
    const a = qe[n];
    r[a ?? n] = t;
  }
  return r;
}
function $e(e, r, n, t) {
  return {
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    planTypeKey: t,
    tiltakforbudType: typeof e.PBLTILTAKFORBUDTYPE == "string" ? e.PBLTILTAKFORBUDTYPE : void 0,
    informasjon: typeof e.INFORMASJON == "string" ? e.INFORMASJON : void 0,
    avgjørelsesdato: e.AVGJDATO ?? void 0,
    gyldigTilDato: e.GYLDIGTILDATO ?? void 0,
    førsteDigitaliseringsdato: e.FORSTEDIGITALISERINGSDATO ?? void 0,
    saksAar: e.SAKSAR ?? void 0,
    saksSekvensnummer: e.SAKSSEKVENSNUMMER ?? void 0,
    geometri: r,
    attributter: { ...e },
    displayValues: _e(n)
  };
}
function D(e) {
  const r = /* @__PURE__ */ new Map();
  for (const n of e)
    if (n.domain instanceof be) {
      const t = /* @__PURE__ */ new Map();
      for (const a of n.domain.codedValues)
        t.set(a.code, a.name);
      r.set(n.name, t);
    }
  return r;
}
function w(e, r) {
  const n = {};
  for (const [t, a] of Object.entries(e)) {
    const o = r.get(t);
    n[t] = o?.get(a) ?? a;
  }
  return n;
}
function ce(e) {
  return e.replace(/'/g, "''");
}
function Y(e) {
  return `'${ce(e)}'`;
}
function Er(e, r) {
  return r.length === 0 ? "1=0" : `${e} IN (${r.map(Y).join(",")})`;
}
const Ve = ae("arealplan:ServicesInitializer");
function Ye() {
  const e = /* @__PURE__ */ new Map(), r = async (o) => {
    try {
      const s = (await de(o, {
        query: { f: "json" },
        responseType: "json"
      })).data?.layers;
      return s ? s.map((R) => ({
        id: R.id,
        name: R.name,
        url: `${o}/${R.id}`,
        geometryType: R.geometryType
      })) : [];
    } catch (i) {
      throw Ve.error(`Feil ved henting av layer-info fra ${o}:`, i), new C(`Kunne ikke laste layer-info: ${i?.message ?? i}`, i);
    }
  }, n = (o) => {
    let i = e.get(o);
    return i || (i = r(o).catch((s) => {
      throw e.delete(o), s;
    }), e.set(o, i)), i;
  };
  return { getLayerInfo: n, getLayerIds: async (o, i) => {
    const s = await n(o);
    if (i && i.length > 0) {
      const R = new Set(i);
      return s.filter((m) => R.has(m.name)).map((m) => m.id);
    }
    return s.filter((R) => R.geometryType === "esriGeometryPolygon").map((R) => R.id);
  }, getLayerMap: async (o) => {
    const i = await n(o);
    return new Map(i.map((s) => [s.name, s]));
  } };
}
const Ce = ae("arealplan:queryFeatureLayers"), Je = 2e3, He = 1e3, We = {
  point: "esriGeometryPoint",
  multipoint: "esriGeometryMultipoint",
  polyline: "esriGeometryPolyline",
  polygon: "esriGeometryPolygon",
  extent: "esriGeometryEnvelope"
};
async function B(e, r, n) {
  return r.layerIds.length === 0 ? [] : (await Promise.all(
    r.layerIds.map((a) => Ue(e, a, r, n))
  )).filter((a) => a !== null);
}
async function Ue(e, r, n, t) {
  const a = {
    where: n.where,
    outSR: n.outputWkid,
    returnGeometry: n.returnGeometry !== !1,
    returnTrueCurves: n.returnTrueCurves ?? !1,
    outFields: n.outFields ? n.outFields.join(",") : "*",
    geometryPrecision: 2,
    f: "json"
  };
  n.geometry && (a.geometryType = We[n.geometry.type] ?? "esriGeometryPolygon", a.inSR = n.geometry.spatialReference?.wkid ?? n.outputWkid, a.geometry = JSON.stringify(n.geometry.toJSON()), a.spatialRel = "esriSpatialRelIntersects");
  const o = [];
  let i = null, s = 0;
  try {
    for (let m = 0; m < He; m++) {
      const h = (await de(`${e}/${r}/query`, {
        query: { ...a, resultOffset: s, resultRecordCount: Je },
        method: "post",
        responseType: "json",
        signal: t?.signal
      })).data, v = h?.features ?? [];
      if (m === 0 && (i = h), o.push(...v), h?.exceededTransferLimit !== !0 || v.length === 0)
        break;
      s += v.length;
    }
  } catch (m) {
    throw t?.signal?.aborted || Qe(m) ? new J() : (Ce.error(`Feil ved query mot ${e}/${r}:`, m), new C(
      `Query mot ${e}/${r} feilet: ${m?.message ?? m}`,
      m
    ));
  }
  return !i || o.length === 0 ? null : { featureSet: Re.fromJSON({ ...i, features: o }), layerId: r };
}
function Qe(e) {
  return typeof e != "object" || e === null ? !1 : e.name === "AbortError";
}
const q = ae("arealplan:arcgisArealplanRepository"), L = 25833;
function _(e) {
  if (e instanceof J)
    throw e;
}
function ze(e) {
  if (!e.settings)
    throw new H("createArcgisArealplanRepository: settings required");
  const r = e.services ?? Ye(), n = () => Object.entries(e.settings.planTypes).filter(([l]) => ve.test(l)).map(([l, y]) => [l, y.url]), t = async (l, y) => {
    const f = n();
    return (await Promise.all(
      f.map(async ([c, u]) => {
        try {
          const b = ee(c), E = await r.getLayerMap(u);
          let g;
          for (const d of b) {
            const k = E.get(d);
            if (k) {
              g = k;
              break;
            }
          }
          return g ? (await B(
            u,
            {
              layerIds: [g.id],
              where: "1=1",
              geometry: l,
              returnGeometry: !1,
              // `*` i stedet for en eksplisitt feltliste: per-lag
              // endepunktet `/{layerId}/query` validerer outFields
              // strengt og avviser HELE queryen om ett felt mangler
              // på laget («'outFields' parameter is invalid»). Det
              // gamle tjeneste-nivå layerDefs-endepunktet var
              // tolerant her. Mapperen plukker felt by-name
              // (WIRE_TO_DOMAIN_KEY), så ekstra felt er uskadelig.
              outputWkid: L
            },
            y
          )).flatMap(({ featureSet: d }) => {
            const k = D(d.fields ?? []);
            return d.features.map(
              (N) => le(
                N.attributes,
                c,
                w(N.attributes, k)
              )
            );
          }) : [];
        } catch (b) {
          return _(b), q.error(`Feil ved henting av planer fra ${c}:`, b), [];
        }
      })
    )).flat();
  }, a = (l) => t(void 0, l), o = (l, y) => t(l, y), i = async (l, y) => (await Promise.all(
    Object.entries(e.settings.planTypes).map(async ([p, c]) => {
      try {
        const u = ee(p);
        if (u.length === 0)
          return [];
        const b = await r.getLayerIds(c.url, u);
        return b.length === 0 ? [] : (await B(
          c.url,
          {
            layerIds: b,
            where: "1=1",
            geometry: l,
            outputWkid: l.spatialReference?.wkid ?? L
          },
          y
        )).map(({ featureSet: g }) => (g.features = g.features.filter(
          (F) => se(l, F.geometry ?? void 0)
        ), { planTypeKey: p, featureSet: g })).filter((g) => g.featureSet.features.length > 0);
      } catch (u) {
        return _(u), q.error(`Feil ved spatial query for ${p}:`, u), [];
      }
    })
  )).flat(), s = async (l, y) => (await i(l, y)).flatMap((p) => {
    const c = D(p.featureSet.fields ?? []);
    return p.featureSet.features.map(
      (u) => le(
        u.attributes,
        p.planTypeKey,
        w(u.attributes, c)
      )
    );
  }), R = async (l, y) => {
    const f = l.spatialReference?.wkid ?? L;
    return (await Promise.all(
      Object.entries(e.settings.planTypes).map(async ([c, u]) => {
        try {
          const b = await r.getLayerIds(
            u.url,
            Z
          );
          return b.length === 0 ? [] : (await B(
            u.url,
            {
              layerIds: b,
              where: "1=1",
              geometry: l,
              outputWkid: f
            },
            y
          )).flatMap(({ featureSet: g }) => {
            const F = D(g.fields ?? []);
            return g.features.filter(
              (d) => se(l, d.geometry ?? void 0)
            ).map(
              (d) => re(
                d.attributes,
                d.geometry ?? void 0,
                w(d.attributes, F),
                c
              )
            );
          });
        } catch (b) {
          return _(b), q.error(`Feil ved delområde-query for ${c}:`, b), [];
        }
      })
    )).flat();
  }, m = async (l, y) => {
    if (l.length === 0)
      return [];
    const f = [], p = [], c = /* @__PURE__ */ new Map(), u = /^([^:\-]+)[:-](\d+)$/, b = /^\{?[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\}?$/;
    for (const d of l) {
      const k = u.exec(d);
      if (k) {
        const N = k[1], P = Number(k[2]);
        if (Number.isFinite(P)) {
          let T = c.get(N);
          T || (T = [], c.set(N, T)), T.push(P);
          continue;
        }
      }
      if (b.test(d)) {
        p.push(d);
        continue;
      }
      f.push(d);
    }
    const E = [];
    f.length > 0 && E.push(`LOKALID IN (${f.map(Y).join(",")})`), p.length > 0 && E.push(`GlobalID IN (${p.map(Y).join(",")})`);
    for (const [d, k] of c)
      E.push(
        `(OBJTYPE = ${Y(d)} AND OBJECTID IN (${k.join(",")}))`
      );
    const g = E.join(" OR ");
    return (await Promise.all(
      Object.entries(e.settings.planTypes).map(async ([d, k]) => {
        try {
          const N = await r.getLayerIds(
            k.url,
            Z
          );
          return N.length === 0 ? [] : (await B(
            k.url,
            {
              layerIds: N,
              where: g,
              outputWkid: L
            },
            y
          )).flatMap(({ featureSet: T }) => {
            const G = D(T.fields ?? []);
            return T.features.map(
              (z) => re(
                z.attributes,
                z.geometry ?? void 0,
                w(z.attributes, G),
                d
              )
            );
          });
        } catch (N) {
          return _(N), q.error(`Feil ved findDelområderByIds for ${d}:`, N), [];
        }
      })
    )).flat();
  }, K = async (l, y, f, p, c) => {
    const u = e.settings.planTypes[y];
    if (!u)
      return [];
    const b = await r.getLayerIds(u.url, Z);
    if (b.length === 0)
      return [];
    const E = c ?? f?.spatialReference?.wkid ?? L;
    return (await B(
      u.url,
      {
        layerIds: b,
        where: `PLANID = '${ce(l)}'`,
        geometry: f,
        outputWkid: E
      },
      p
    )).flatMap(({ featureSet: F }) => {
      const d = D(F.fields ?? []);
      return F.features.filter(
        (k) => me(f, k.geometry ?? void 0, { minAreaM2: 1 }).keep
      ).map(
        (k) => re(
          k.attributes,
          k.geometry ?? void 0,
          w(k.attributes, d),
          y
        )
      );
    });
  }, h = async (l, y) => {
    const f = e.settings.planTypes[l.planTypeKey];
    if (!f || l.objectId == null)
      return null;
    const p = ee(l.planTypeKey), c = await r.getLayerMap(f.url);
    let u;
    for (const E of p) {
      const g = c.get(E);
      if (g) {
        u = g;
        break;
      }
    }
    return u ? (await B(
      f.url,
      {
        layerIds: [u.id],
        where: `OBJECTID = ${l.objectId}`,
        returnGeometry: !0,
        outFields: ["OBJECTID"],
        outputWkid: L
      },
      y
    ))[0]?.featureSet.features[0]?.geometry ?? null : null;
  }, v = async (l, y, f, p, c) => {
    const u = l.spatialReference?.wkid ?? L, b = Object.entries(e.settings.planTypes).filter(
      ([g]) => y.test(g)
    );
    return (await Promise.all(
      b.map(async ([g, F]) => {
        try {
          const k = (await r.getLayerInfo(F.url)).filter((P) => P.geometryType != null).map((P) => P.id);
          return k.length === 0 ? [] : (await B(
            F.url,
            {
              layerIds: k,
              where: "1=1",
              geometry: l,
              outputWkid: u
            },
            c
          )).flatMap(({ featureSet: P }) => {
            const T = D(P.fields ?? []);
            return P.features.map(
              (G) => f(
                G.attributes,
                G.geometry ?? void 0,
                w(G.attributes, T),
                g
              )
            );
          });
        } catch (d) {
          return _(d), q.error(`Feil ved ${p}-query for ${g}:`, d), [];
        }
      })
    )).flat();
  };
  return {
    findAll: a,
    findByPoint: o,
    findByPolygon: s,
    findFeaturesByPolygon: i,
    findDelområderByPolygon: R,
    findDelområderByIds: m,
    getDelområderForPlan: K,
    getGeometry: h,
    findDispensasjonerByPolygon: (l, y) => v(
      l,
      Te,
      (f, p, c, u) => xe(
        f,
        p,
        c,
        u
      ),
      "dispensasjon",
      y
    ),
    findMidlertidigeForbudByPolygon: (l, y) => v(
      l,
      he,
      (f, p, c, u) => $e(
        f,
        p,
        c,
        u
      ),
      "midlertidig forbud",
      y
    )
  };
}
function Xe(e) {
  const { kommunenummer: r, gardsnummer: n, bruksnummer: t, festenummer: a, seksjonsnummer: o } = e;
  if (n == null || t == null)
    return;
  let i = "";
  return r != null && (i += `${r}-`), i += `${n}/${t}`, a && (i += `-${a}`), o && (i += `/${o}`), i;
}
function ue(e, r) {
  return {
    objectId: e.OBJECTID,
    id: String(e.matrikkelid ?? e.OBJECTID),
    kommunenummer: e.kommunenummer != null ? Number(e.kommunenummer) : void 0,
    gardsnummer: e.gardsnummer != null ? Number(e.gardsnummer) : void 0,
    bruksnummer: e.bruksnummer != null ? Number(e.bruksnummer) : void 0,
    festenummer: e.festenummer != null ? Number(e.festenummer) : void 0,
    seksjonsnummer: e.seksjonsnummer != null ? Number(e.seksjonsnummer) : void 0,
    matrikkelId: e.matrikkelid != null ? String(e.matrikkelid) : void 0,
    matrikkelnummerTekst: e.matrikkelnummer ?? Xe(e),
    geometri: r
  };
}
function Ze(e) {
  if (!e.teigerUrl)
    throw new H("createArcgisTeigRepository: teigerUrl required");
  let r = null;
  const n = () => (r ?? (r = new Ae({ url: e.teigerUrl })), r), t = async (o, i) => {
    try {
      return await o();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? new J() : new C(`${i} feilet: ${s?.message ?? s}`, s);
    }
  }, a = async (o, i) => t(async () => {
    const s = n().createQuery();
    return s.where = o, s.outFields = ["*"], s.returnGeometry = !0, (await n().queryFeatures(s, { signal: i?.signal })).features.map(
      (m) => ue(
        m.attributes,
        m.geometry
      )
    );
  }, "TeigRepository.query");
  return {
    findByMatrikkel: async (o, i) => {
      const s = [];
      return s.push(`gardsnummer = ${o.gardsnummer}`), s.push(`bruksnummer = ${o.bruksnummer}`), s.push(`kommunenummer = ${o.kommunenummer}`), o.festenummer != null && s.push(`festenummer = ${o.festenummer}`), o.seksjonsnummer != null && s.push(`seksjonsnummer = ${o.seksjonsnummer}`), a(s.join(" AND "), i);
    },
    findByGeometry: async (o, i) => t(async () => {
      const s = n().createQuery();
      return s.geometry = o, s.spatialRelationship = "intersects", s.outFields = ["*"], s.returnGeometry = !0, (await n().queryFeatures(s, { signal: i?.signal })).features.map(
        (m) => ue(
          m.attributes,
          m.geometry
        )
      );
    }, "TeigRepository.findByGeometry")
  };
}
function Nr(e) {
  if (!e.settings)
    throw new H("createArealplanClient: settings required");
  const r = ze({ settings: e.settings }), n = e.settings.teigerUrl ? Ze({ teigerUrl: e.settings.teigerUrl }) : void 0;
  return { arealplaner: r, teiger: n };
}
const A = {
  all: ["arealplan"],
  list: () => ["arealplan", "list"],
  byPolygon: (e, r, n, t, a) => ["arealplan", "byPolygon", e, r, n, t, a],
  featuresByPolygon: (e, r, n, t, a) => ["arealplan", "featuresByPolygon", e, r, n, t, a],
  delområder: {
    all: ["arealplan", "delområder"],
    byPolygon: (e, r, n, t, a) => ["arealplan", "delområder", "byPolygon", e, r, n, t, a],
    byIds: (e) => ["arealplan", "delområder", "byIds", [...e].sort().join(",")],
    forPlan: (e, r, n = 0, t = 0, a = 0, o = 0, i = 0) => [
      "arealplan",
      "delområder",
      "forPlan",
      e,
      r,
      n,
      t,
      a,
      o,
      i
    ]
  },
  geometry: (e, r, n) => ["arealplan", "geometry", e, r, n ?? 0],
  teiger: {
    byMatrikkel: (e, r, n, t, a) => ["arealplan", "teiger", "matrikkel", e, r, n, t, a],
    byGeometry: (e, r, n) => ["arealplan", "teiger", "geometry", e, r, n]
  },
  dispensasjoner: {
    byPolygon: (e, r, n, t, a) => ["arealplan", "dispensasjoner", "byPolygon", e, r, n, t, a]
  },
  midlertidigeForbud: {
    byPolygon: (e, r, n, t, a) => ["arealplan", "midlertidigeForbud", "byPolygon", e, r, n, t, a]
  }
};
async function er(e, r) {
  return e.arealplaner.findAll(r);
}
async function rr(e, r, n) {
  return e.arealplaner.findByPolygon(r.polygon, n);
}
async function nr(e, r, n) {
  return e.arealplaner.findFeaturesByPolygon(r.polygon, n);
}
async function tr(e, r, n) {
  return e.arealplaner.findDelområderByPolygon(r.polygon, n);
}
async function ar(e, r, n) {
  return e.arealplaner.findDelområderByIds(r.omradeIds, n);
}
async function or(e, r, n) {
  return e.arealplaner.getDelområderForPlan(
    r.planId,
    r.planTypeKey,
    r.polygon,
    n,
    r.outputWkid
  );
}
async function ir(e, r, n) {
  return e.arealplaner.getGeometry(r.plan, n);
}
async function sr(e, r, n) {
  return e.teiger.findByMatrikkel(r, n);
}
async function lr(e, r, n) {
  return e.teiger.findByGeometry(r.geometry, n);
}
async function ur(e, r, n) {
  return e.arealplaner.findDispensasjonerByPolygon(r.polygon, n);
}
async function dr(e, r, n) {
  return e.arealplaner.findMidlertidigeForbudByPolygon(r.polygon, n);
}
const V = 5 * 6e4, j = 6e4, mr = (e) => ({
  list: () => O({
    queryKey: A.list(),
    queryFn: ({ signal: r }) => er(e, { signal: r }),
    staleTime: V
  }),
  byPolygon: (r) => O({
    queryKey: r ? A.byPolygon(
      r.extent?.xmin ?? 0,
      r.extent?.ymin ?? 0,
      r.extent?.xmax ?? 0,
      r.extent?.ymax ?? 0,
      r.spatialReference?.wkid ?? 0
    ) : A.byPolygon(0, 0, 0, 0, 0),
    queryFn: ({ signal: n }) => rr(e, { polygon: r }, { signal: n }),
    enabled: r != null,
    staleTime: j
  }),
  featuresByPolygon: (r) => O({
    queryKey: r ? A.featuresByPolygon(
      r.extent?.xmin ?? 0,
      r.extent?.ymin ?? 0,
      r.extent?.xmax ?? 0,
      r.extent?.ymax ?? 0,
      r.spatialReference?.wkid ?? 0
    ) : A.featuresByPolygon(0, 0, 0, 0, 0),
    queryFn: ({ signal: n }) => nr(e, { polygon: r }, { signal: n }),
    enabled: r != null,
    staleTime: j
  }),
  delområder: {
    byPolygon: (r) => O({
      queryKey: r ? A.delområder.byPolygon(
        r.extent?.xmin ?? 0,
        r.extent?.ymin ?? 0,
        r.extent?.xmax ?? 0,
        r.extent?.ymax ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : A.delområder.byPolygon(0, 0, 0, 0, 0),
      queryFn: ({ signal: n }) => tr(e, { polygon: r }, { signal: n }),
      enabled: r != null,
      staleTime: j
    }),
    byIds: (r) => O({
      queryKey: A.delområder.byIds(r),
      queryFn: ({ signal: n }) => ar(e, { omradeIds: r }, { signal: n }),
      enabled: r.length > 0,
      staleTime: j
    }),
    forPlan: (r, n, t, a) => O({
      // outputWkid MÅ inn i nøkkelen — uten polygon skiller den ellers
      // ikke 25832- fra 25833-resultater, og cachen ville servert feil-SR
      // geometri til kart-rendering.
      queryKey: t ? A.delområder.forPlan(
        r ?? "",
        n ?? "",
        t.extent?.xmin ?? 0,
        t.extent?.ymin ?? 0,
        t.extent?.xmax ?? 0,
        t.extent?.ymax ?? 0,
        t.spatialReference?.wkid ?? 0
      ) : A.delområder.forPlan(
        r ?? "",
        n ?? "",
        0,
        0,
        0,
        0,
        a ?? 0
      ),
      queryFn: ({ signal: o }) => or(
        e,
        {
          planId: r,
          planTypeKey: n,
          polygon: t ?? void 0,
          outputWkid: a
        },
        { signal: o }
      ),
      enabled: !!(r && n),
      staleTime: j
    })
  },
  geometry: (r) => O({
    queryKey: r ? A.geometry(r.planId, r.planTypeKey, r.objectId) : A.geometry("", "", 0),
    queryFn: ({ signal: n }) => ir(e, { plan: r }, { signal: n }),
    enabled: r != null,
    staleTime: V
  }),
  dispensasjoner: {
    byPolygon: (r) => O({
      queryKey: r ? A.dispensasjoner.byPolygon(
        r.extent?.xmin ?? 0,
        r.extent?.ymin ?? 0,
        r.extent?.xmax ?? 0,
        r.extent?.ymax ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : A.dispensasjoner.byPolygon(0, 0, 0, 0, 0),
      queryFn: ({ signal: n }) => ur(e, { polygon: r }, { signal: n }),
      enabled: r != null,
      staleTime: j
    })
  },
  midlertidigeForbud: {
    byPolygon: (r) => O({
      queryKey: r ? A.midlertidigeForbud.byPolygon(
        r.extent?.xmin ?? 0,
        r.extent?.ymin ?? 0,
        r.extent?.xmax ?? 0,
        r.extent?.ymax ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : A.midlertidigeForbud.byPolygon(0, 0, 0, 0, 0),
      queryFn: ({ signal: n }) => dr(e, { polygon: r }, { signal: n }),
      enabled: r != null,
      staleTime: j
    })
  },
  teiger: {
    byMatrikkel: (r) => O({
      queryKey: A.teiger.byMatrikkel(
        r?.kommunenummer ?? 0,
        r?.gardsnummer ?? 0,
        r?.bruksnummer ?? 0,
        r?.festenummer ?? 0,
        r?.seksjonsnummer ?? 0
      ),
      queryFn: ({ signal: n }) => {
        if (!e.teiger)
          throw new Error("TeigRepository not configured");
        return sr(
          { teiger: e.teiger },
          r,
          { signal: n }
        );
      },
      enabled: r != null && e.teiger != null,
      staleTime: V
    }),
    byGeometry: (r) => O({
      queryKey: r ? A.teiger.byGeometry(
        r.x ?? 0,
        r.y ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : A.teiger.byGeometry(0, 0, 0),
      queryFn: ({ signal: n }) => {
        if (!e.teiger)
          throw new Error("TeigRepository not configured");
        return lr(
          { teiger: e.teiger },
          { geometry: r },
          { signal: n }
        );
      },
      enabled: r != null && e.teiger != null,
      staleTime: V
    })
  }
});
function te(e, r) {
  if (e.attributter[r] != null)
    return e.attributter[r];
  const n = r.toLowerCase();
  for (const [t, a] of Object.entries(e.attributter))
    if (t.toLowerCase() === n && a != null)
      return a;
}
function ye(e, r) {
  return te(e, r) ?? e.displayValues[r];
}
function fe(e) {
  return Array.from(
    new Set(
      e.filter((r) => r != null).map((r) => String(r).trim()).filter(Boolean)
    )
  );
}
function Fr(e) {
  if (e.arealformål)
    return [e.arealformål];
  const r = $(e.objtype);
  if (!r)
    return [];
  const n = ye(e, r.typeFelt);
  return fe([n]);
}
function Or(e) {
  const r = $(e.objtype), n = r ? ye(e, r.headingFelt) : void 0, t = e.objtype, a = e.objectId, o = te(e, "GlobalID"), i = te(e, "LOKALID"), s = o == null ? void 0 : String(o).replace(/[{}]/g, "").trim(), R = [
    n,
    i,
    o,
    s,
    s ? s.toLowerCase() : void 0,
    s ? s.toUpperCase() : void 0,
    s ? `{${s}}` : void 0,
    s ? `{${s.toUpperCase()}}` : void 0,
    a,
    t && a ? `${t}-${a}` : void 0,
    a ? `undefined-${a}` : void 0
  ];
  return fe(R);
}
const W = Ne(null), Sr = ({
  client: e,
  children: r
}) => {
  const n = Fe(
    () => ({
      client: e,
      queries: mr({
        arealplaner: e.arealplaner,
        teiger: e.teiger
      })
    }),
    [e]
  );
  return /* @__PURE__ */ Ee(W.Provider, { value: n, children: r });
};
function Ir() {
  const e = oe(W);
  if (!e)
    throw new Error("useArealplanClient må brukes innenfor en <ArealplanClientProvider>");
  return e.client;
}
function Pr() {
  return oe(W)?.client ?? null;
}
function I() {
  const e = oe(W);
  if (!e)
    throw new Error("useArealplanQueries må brukes innenfor en <ArealplanClientProvider>");
  return e.queries;
}
function vr() {
  const e = I();
  return S(e.list());
}
function Tr(e) {
  const r = I();
  return S(r.byPolygon(e));
}
function hr(e) {
  const r = I();
  return S(r.featuresByPolygon(e));
}
function Br(e) {
  const r = I();
  return S(r.geometry(e));
}
function Lr(e) {
  const r = I();
  return S(r.dispensasjoner.byPolygon(e));
}
function jr(e) {
  const r = I();
  return S(r.midlertidigeForbud.byPolygon(e));
}
function Mr(e) {
  const r = I();
  return S(r.delområder.byPolygon(e));
}
function Kr(e) {
  const r = I();
  return S(r.delområder.byIds(e));
}
function Dr(e, r, n, t) {
  const a = I();
  return S(a.delområder.forPlan(e, r, n, t));
}
function wr(e) {
  const r = I();
  return S(r.teiger.byMatrikkel(e));
}
function Gr(e) {
  const r = I();
  return S(r.teiger.byGeometry(e));
}
class xr {
  constructor(r = {}) {
    this.data = r;
  }
  async findAll() {
    return [...this.data.arealplaner ?? []];
  }
  async findByPoint() {
    return [...this.data.arealplaner ?? []];
  }
  async findByPolygon() {
    return [...this.data.arealplaner ?? []];
  }
  async findFeaturesByPolygon() {
    return [];
  }
  async findDelområderByPolygon() {
    return [...this.data.delområder ?? []];
  }
  async findDelområderByIds(r) {
    const n = new Set(r);
    return (this.data.delområder ?? []).filter((t) => t.omradeId && n.has(t.omradeId));
  }
  async getDelområderForPlan(r) {
    return (this.data.delområder ?? []).filter((n) => n.planId === r);
  }
  async getGeometry() {
    return null;
  }
  async findDispensasjonerByPolygon() {
    return [...this.data.dispensasjoner ?? []];
  }
  async findMidlertidigeForbudByPolygon() {
    return [...this.data.midlertidigeForbud ?? []];
  }
}
class qr {
  constructor(r = []) {
    this.teiger = r;
  }
  async findByMatrikkel(r) {
    return this.teiger.filter(
      (n) => n.kommunenummer === r.kommunenummer && n.gardsnummer === r.gardsnummer && n.bruksnummer === r.bruksnummer && (r.festenummer == null || n.festenummer === r.festenummer) && (r.seksjonsnummer == null || n.seksjonsnummer === r.seksjonsnummer)
    );
  }
  async findByGeometry() {
    return [...this.teiger];
  }
}
export {
  Z as ALL_DELOMRADE_SUBLAYER_NAMES,
  J as AbortedError,
  Sr as ArealplanClientProvider,
  M as ArealplanError,
  Pe as AuthError,
  H as ConfigurationError,
  xr as FakeArealplanRepository,
  qr as FakeTeigRepository,
  C as NetworkError,
  Se as NotFoundError,
  ne as OBJTYPE_REGISTRY,
  Ie as ValidationError,
  le as arealplanFromAttrs,
  A as arealplanKeys,
  mr as arealplanQueries,
  D as buildFieldLookup,
  Er as buildInClause,
  ze as createArcgisArealplanRepository,
  Ze as createArcgisTeigRepository,
  Nr as createArealplanClient,
  re as delområdeFromFeature,
  xe as dispensasjonFromFeature,
  Ar as domain,
  ce as escapeSqlValue,
  nr as findArealplanFeaturesByPolygon,
  rr as findArealplanerByPolygon,
  ar as findDelområderByIds,
  tr as findDelområderByPolygon,
  ur as findDispensasjonerByPolygon,
  dr as findMidlertidigeForbudByPolygon,
  $ as findObjtypeInfo,
  lr as findTeigByGeometry,
  sr as findTeigByMatrikkel,
  Fr as getArealformålCandidates,
  ir as getArealplanGeometry,
  Or as getOmrådeIdCandidates,
  ee as getPlanomradeLagnavn,
  er as loadAlleArealplaner,
  or as loadDelområderForArealplan,
  w as mapDisplayValues,
  $e as midlertidigForbudFromFeature,
  Oe as planKey,
  Y as qv,
  ue as teigFromAttrs,
  Ir as useArealplanClient,
  Pr as useArealplanClientOptional,
  hr as useArealplanFeaturesByPolygon,
  Br as useArealplanGeometry,
  vr as useArealplaner,
  Tr as useArealplanerByPolygon,
  Kr as useDelområderByIds,
  Mr as useDelområderByPolygon,
  Dr as useDelområderForArealplan,
  Lr as useDispensasjonerByPolygon,
  jr as useMidlertidigeForbudByPolygon,
  Gr as useTeigByGeometry,
  wr as useTeigByMatrikkel
};
//# sourceMappingURL=index.mjs.map
